<template>
  <section class="bg-static-info-low">
    <div class="flex h-[60px] items-center">
      <Breadcrumb />
    </div>
    <div class="py-28">
      <div class="mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
        <h1 class="punchline md:text-center">
          {{ i18n(translations.headingLine1) }}
          <br class="md:hidden" />
          {{ i18n(translations.headingLine2) }}
        </h1>
      </div>
    </div>
  </section>
  <div v-if="isUserAuthenticated" class="bg-static-info-low">
    <OrdersSection />
  </div>
  <div v-else class="bg-static-info-low md:pb-48">
    <div
      class="mx-auto md:grid md:max-w-[1184px] md:grid-cols-2 md:gap-80 md:px-32"
    >
      <SuggestLoginSection contained />
      <section class="relative px-24 py-28 md:p-0">
        <SeoBlock />
      </section>
    </div>
  </div>
  <section
    v-if="isUserAuthenticated"
    class="bg-surface-brand-low relative py-28 md:py-[56px]"
  >
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <SeoBlock two-columns />
    </div>
  </section>
  <FAQSection />
  <section class="relative py-28">
    <div class="relative mx-auto max-w-full px-24 md:max-w-[900px] md:px-32">
      <FooterBlock />
    </div>
  </section>
  <Intercom
    data-test="intercom"
    :hide-launcher="false"
    @ready="onIntercomReady"
  />
</template>

<script setup lang="ts">
import { useHead, useRoute } from '#imports'

import Intercom from '@backmarket/nuxt-layer-care-platform/intercom/Intercom.vue'
import type { IntercomApi } from '@backmarket/nuxt-layer-care-platform/intercom/intercom.types'
import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'

import Breadcrumb from '~/scopes/help-center/components/Breadcrumb/Breadcrumb.vue'

import translations from './HelpCenterHome.translations'
import FAQSection from './components/FAQSection/FAQSection.vue'
import FooterBlock from './components/FooterBlock/FooterBlock.vue'
import OrdersSection from './components/OrdersSection/OrdersSection.vue'
import SeoBlock from './components/SeoBlock/SeoBlock.vue'
import SuggestLoginSection from './components/SuggestLoginSection/SuggestLoginSection.vue'

const i18n = useI18n()
const route = useRoute()
const { isUserAuthenticated } = useUserStore()

useHead({
  title: i18n(translations.helpCenterPageTitle),
  htmlAttrs: { lang: useI18nLocale() },
})

const onIntercomReady = (intercomApi: IntercomApi) => {
  if (route.query.show_intercom === 'true') {
    intercomApi('show')

    return
  }

  if (route.query.intercom_ticket_id) {
    intercomApi('showConversation', route.query.intercom_ticket_id.toString())
  }
}
</script>
